import { RecurringType } from '@app/common/types/enum/recurringType';
import { TransferType } from '@app/common/types/enum/transferType';

import { ChannelId } from '@make-transfer/types/common';
import { InvestmentPaymentType } from '@make-transfer/types/investment';

export class PaymentDetails {
  from: string;

  to: string;

  fromAccountNumber: string;

  toAccountNumber: string;

  fromAccountId: string;

  fromAccountType: string;

  toAccountId: string;

  toAccountType: string;

  amount: number;

  transferType: TransferType | null;

  paymentOption: string | null;

  isDynamicAmount: boolean | null;

  dynamicAmountDescription: string | null;

  paymentOptionDisplayName: string | null;

  scheduledDate: Date;

  recurringStartDate: Date;

  recurringStartDate1: Date;

  recurringStartDate2: Date;

  recurringType: RecurringType | null;

  recurringNumber: number;

  recurringEndDate: Date;

  memo: string;

  channelId: ChannelId;

  investmentPaymentType: InvestmentPaymentType | null;

  constructor() {
    this.from = '';
    this.to = '';
    this.fromAccountNumber = '';
    this.fromAccountType = '';
    this.toAccountNumber = '';
    this.fromAccountId = '';
    this.toAccountId = '';
    this.toAccountType = '';
    this.amount = 0;
    this.transferType = null;
    this.paymentOption = null;
    this.isDynamicAmount = false;
    this.dynamicAmountDescription = null;
    this.paymentOptionDisplayName = null;
    this.scheduledDate = new Date();
    this.recurringStartDate = new Date();
    this.recurringStartDate1 = new Date();
    this.recurringStartDate2 = new Date();
    this.recurringType = null;
    this.recurringNumber = 0;
    this.recurringEndDate = new Date();
    this.memo = '';
    this.channelId = ChannelId.Internal;
    this.investmentPaymentType = null;
  }
}
